import { CarouselProps as AntdCarouselProps } from 'antd';
import React from 'react';
import { withTheme } from '../ThemeProvider';
import { StyledCarousel } from './styles';

export interface CarouselProps extends AntdCarouselProps {
  children: React.ReactNode;
  theme?: any;
}

const CarouselComponent: React.FC<CarouselProps> = ({ children, ...rest }) => {
  return <StyledCarousel {...rest}>{children}</StyledCarousel>;
};

export const Carousel = withTheme(CarouselComponent);
